import React, { Suspense } from 'react';

import { IconButton } from '@material-ui/core';
import { IconButtonProps } from '@material-ui/core/IconButton';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Info } from '@material-ui/icons';
import { Tooltip } from 'embeds/components';

import QueryPatientAuditContactTooltip from './QueryPatientAuditContactTooltip';

const styles = () => ({
  iconButton: {
    padding: 0,
    marginLeft: 2,
  },
});

export interface WrapperQueryPatientAuditContactTooltipProps extends WithStyles<typeof styles> {
  patientId: string;
}

interface TooltipIconButtonProps extends IconButtonProps {
  iconColor: 'action' | 'primary';
}

const TooltipIconButton = ({ iconColor, ...rest }: TooltipIconButtonProps) => (
  <IconButton {...rest}>
    <Info fontSize="small" color={iconColor} />
  </IconButton>
);

const WrapperQueryPatientAuditContactTooltip = ({
  patientId,
  classes,
}: WrapperQueryPatientAuditContactTooltipProps) => {
  const [openTooltip, setOpenTooltip] = React.useState(false);

  return (
    <>
      {openTooltip ? (
        <Suspense
          fallback={
            <Tooltip title="loading...">
              <TooltipIconButton className={classes.iconButton} iconColor="primary" />
            </Tooltip>
          }
        >
          <QueryPatientAuditContactTooltip patientId={patientId}>
            <TooltipIconButton
              iconColor="primary"
              className={classes.iconButton}
              onMouseLeave={() => setOpenTooltip(false)}
            />
          </QueryPatientAuditContactTooltip>
        </Suspense>
      ) : (
        <TooltipIconButton
          iconColor="action"
          className={classes.iconButton}
          onMouseEnter={() => setOpenTooltip(true)}
        />
      )}
    </>
  );
};

export default withStyles(styles)(WrapperQueryPatientAuditContactTooltip);
